import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeEntryManagementComponent } from './components/time-entry-management/time-entry-management.component';

@NgModule({
  declarations: [TimeEntryManagementComponent],
  imports: [CommonModule],
})
export class ProjectAdminModule {}
